export const ATTRIBUTION_DIMENSIONS = [
  {
    key: 'utm_source',
    filterKey: 'utmSource',
    i18nKey: 'UTM_SOURCE',
    icon: 'i-lucide-share-2',
  },
  {
    key: 'utm_medium',
    filterKey: 'utmMedium',
    i18nKey: 'UTM_MEDIUM',
    icon: 'i-lucide-radio',
  },
  {
    key: 'utm_campaign',
    filterKey: 'utmCampaign',
    i18nKey: 'UTM_CAMPAIGN',
    icon: 'i-lucide-megaphone',
  },
  {
    key: 'utm_term',
    filterKey: 'utmTerm',
    i18nKey: 'UTM_TERM',
    icon: 'i-lucide-search',
  },
  {
    key: 'utm_content',
    filterKey: 'utmContent',
    i18nKey: 'UTM_CONTENT',
    icon: 'i-lucide-layout-template',
  },
  {
    key: 'ad_title',
    filterKey: 'adTitle',
    i18nKey: 'AD_TITLE',
    icon: 'i-lucide-image',
  },
];

export const ATTRIBUTION_UNATTRIBUTED = 'unattributed';
